import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private activeSpinners = 0;
  public isLoading = signal<boolean>(false);

  show(): void {
    this.activeSpinners++;
    if (this.activeSpinners === 1) {
      this.isLoading.set(true);
    }
  }

  hide(): void {
    this.activeSpinners--;
    if (this.activeSpinners === 0) {
      setTimeout(() => {
        this.isLoading.set(false);
      }, 100);
    }
  }
}
